// src/pages/Defesa/AgendarDefesaPage.jsx
import React from 'react';
import AgendarDefesaForm from '../../components/Defesa/AgendarDefesaForm';

const AgendarDefesaPage = () => {
  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-bold">Agendar Defesa</h1>
      <AgendarDefesaForm onSuccess={() => alert('Defesa agendada com sucesso!')} />
    </div>
  );
};

export default AgendarDefesaPage;
